// @ts-nocheck
/* eslint-disable */
import SceneMarker from "./marker";

export default class SceneMarkerPOI extends SceneMarker {
	/**
	 * Vytvoreni POI markeru.
	 *
	 * @param  {SceneCoords} coords Souradnice
	 * @param  {Number|String} [id] Volitelne ID
	 * @param  {Object} [opts] Volitelny objekt s konfiguraci
	 */
	constructor(scene, itemId, coords, id, opts) {
		super(scene, itemId, coords, id, opts);

		this._visual = {};
		this._source = null;
		this._plainId = null;
		this._activeState = {
			state: false,
			noAnim: false
		};
		this._popupCb = null;
		this._cardOpts = {};
		this._cardRemoved = false;
		this._visualChanged = false;
		this._title = "";
		this._popupData = null;
		this._fromData = null;
	}

	/**
	 * Informace ohledne entity ve scene.
	 *
	 * @return {Object}
	 */
	get featureInfo() {
		return {
			name: "SceneMarkerPOI",
			type: "marker"
		};
	}

	/**
	 * Souhrn vsech dat, ktere vyuziva visualiser pri vytvoreni.
	 *
	 * @return {Object}
	 */
	getCreateData() {
		let rd = super.getCreateData();

		rd.visual = this._visual;
		rd.source = this._source;
		rd.plainId = this._plainId;
		rd.activeState = this._activeState;
		rd.popupCb = this._popupCb;
		rd.cardOpts = this._cardOpts;
		rd.cardRemoved = this._cardRemoved;
		rd.popupdata = this._popupData;
		rd.fromData = this._fromData;

		return rd;
	}

	/**
	 * Naplneni dat markeru ze vstupnich POI dat.
	 *
	 * @param  {Object} data Vstupni data
	 */
	fromData(data) {
		this._coords = this._scene.coordsFromWGS84(data.mark.lon, data.mark.lat);
		this._id = data.source + data.id;
		this._fromData = data;

		// ostatni data
		this._title = "";
		this._source = data.source;
		this._plainId = data.id;
	}

	/**
	 * Nastaveni zdroje markeru.
	 *
	 * @param {String} source Novy zdroj
	 */
	setSource(source) {
		this._source = source;

		this._onChange(this._scene.featureEvent("markerPOISetSource", true, true), arguments);

		return this;
	}

	/**
	 * Nastaveni ID markeru.
	 *
	 * @param {Number} plainId Nove ID
	 */
	setPlainId(plainId) {
		this._plainId = plainId;

		this._onChange(this._scene.featureEvent("markerPOISetPlainId", true, true), arguments);

		return this;
	}

	/**
	 * Nastaveni vizualni podoby markeru.
	 *
	 * @param  {Object} visual Konfigurace s novym vzhledem
	 */
	setVisual(visual) {
		for (let p in visual) { this._visual[p] = visual[p]; }

		this._onChange(this._scene.featureEvent("markerPOISetVisual", true, true), arguments);
	}

	/**
	 * Je marker aktivni?
	 *
	 * @param  {Boolean} state Novy stav
	 * @param {Boolean} [noAnim = false] Neanimovat
	 */
	setActive(state, noAnim) {
		this._activeState.state = state;
		this._activeState.noAnim = noAnim;

		this._onChange(this._scene.featureEvent("markerPOISetActive", true, true), arguments);
	}

	/**
	 * Vytvoreni vyjizdeci karty (bubliny)
	 *
	 * @param  {Function} cb Callback funkce
	 */
	setPopupCallback(cb) {
		this._popupCb = cb;

		this._onChange(this._scene.featureEvent("markerPOISetPopupCb", true, true), arguments);
	}

	/**
	 * Nastaveni konfigurace pro kartu.
	 *
	 * @param  {Object} options Konfigurace
	 */
	setCardOptions(options) {
		for (let p in options) { this._cardOpts[p] = options[p]; }

		this._onChange(this._scene.featureEvent("markerPOISetCardOptions", true, true), arguments);
	}

	/**
	 * Odebrani karty.
	 */
	removeCard() {
		this._cardRemoved = true;

		this._onChange(this._scene.featureEvent("markerPOIRemoveCard", true, true), arguments);
	}

	/**
	 * Posunuti karty.
	 */
	moveCard() {
		this._onChange(this._scene.featureEvent("markerPOIMoveCard", true, true), arguments);
	}

	/**
	 * Vytvoreni karty ze vstupnich POI dat.
	 *
	 * @param  {Object} data Vstupni data
	 */
	setPopupFromPOI(poi) {
		this._popupData = poi;

		this._onChange(this._scene.featureEvent("markerPOISetPopupFromPOI", true, true), arguments);
	}

	/**
	 * Ziskani vizualni podoby markeru.
	 *
	 * @return {Object}
	 */
	getVisual() {
		return this._visual;
	}

	/**
	 * Ziskani zdroje markeru.
	 *
	 * @return {String}
	 */
	getSource() {
		return this._source;
	}

	/**
	 * Ziskani ID markeru.
	 *
	 * @return {Number}
	 */
	getPlainId() {
		return this._plainId;
	}

	/**
	 * Jedna se o detail? Marker reprezentuje detail.
	 *
	 * @return {Boolean}
	 */
	isDetail() {
		return !!this._visual.detail;
	}

	/**
	 * Ziskani popisku znacky.
	 *
	 * @return {String}
	 */
	getTitle() {
		return this._title || this._options.title;
	}
}
